export const templateBrief = `<h1>Content Goals</h1>
<p>We're looking for creators to:</p>
<ul>
<li>Create engaging content showcasing our app's key features</li>
<li>Share authentic experiences using our app</li>
<li>Help build brand awareness and drive app installs</li>
</ul>

<h1>Content Guidelines</h1>

<h2>What Works Well</h2>
<ul>
<li>Tutorial-style content showing how to use specific features</li>
<li>Before/after transformations or results</li>
<li>Day-in-the-life content incorporating our app</li>
<li>Authentic testimonials and user experiences</li>
<li>Quick tips and tricks for getting the most out of the app</li>
</ul>

<h2>Content Examples</h2>
<ol>
<li>[INSERT LINK]</li>
<li>[INSERT LINK]</li>
<li>[INSERT LINK]</li>
</ol>

<h2>Tone & Style</h2>
<ul>
<li>Authentic and relatable</li>
<li>Educational but entertaining</li>
<li>Professional yet approachable</li>
<li>Positive and solution-focused</li>
</ul>

<h2>Do's</h2>
<ul>
<li>Demonstrate actual app features and functionality</li>
<li>Share personal experiences and results</li>
<li>Include clear call-to-actions for app installation</li>
<li>Maintain high production quality</li>
<li>Show app interface clearly when relevant</li>
</ul>

<h2>Don'ts</h2>
<ul>
<li>No misleading claims or false promises</li>
<li>Avoid negative comparisons with competitors</li>
<li>Don't share sensitive user information</li>
<li>No inappropriate or offensive content</li>
<li>Don't make medical/financial claims unless verified</li>
</ul>

<h1>Posting Guidelines</h1>
<ul>
<li>Tag our official accounts</li>
<li>Use the following hashtags: [INSERT HASHTAGS]</li>
<li>Post during peak engagement hours (specific to your timezone)</li>
</ul>

<h1>Key Messaging Points</h1>
<ul>
<li><strong>Main value proposition:</strong> [Your app's main benefit]</li>
<li><strong>Target audience:</strong> [Who benefits most from your app]</li>
<li><strong>Key differentiators:</strong> [What makes your app unique]</li>
<li><strong>Current user testimonials:</strong> [If available]</li>
</ul>

<p><strong>We're excited to see what you create!</strong></p>`;

export const challengeTemplateBrief = `<h1>Challenge Campaign Brief</h1>

<h2>Challenge Overview</h2>
<p>Create content that showcases our app in a creative and engaging way! This is an open challenge where creators earn based on their video performance.</p>

<h2>Challenge Requirements</h2>
<p>To be eligible for payment, your content must:</p>
<ul>
<li>Include at least one clear app screenshot with our logo visible</li>
<li>Show actual usage of our app in action</li>
<li>Be posted on approved platforms only</li>
<li>Include required hashtags and mentions</li>
</ul>

<h2>Content Ideas That Perform Well</h2>
<ul>
<li>App transformation videos (before/after)</li>
<li>Feature tutorials with your own twist</li>
<li>Day-in-the-life content featuring our app</li>
<li>Creative challenges using our app's features</li>
<li>User experience stories and testimonials</li>
</ul>

<h2>Payment Structure</h2>
<ul>
<li>You earn $[X] CPM (per 1,000 views) for eligible content</li>
<li>AI automatically verifies posts against requirements</li>
<li>Payments processed monthly based on verified views</li>
<li>You can challenge AI decisions for manual review</li>
</ul>

<h2>Posting Guidelines</h2>
<h3>Required Elements:</h3>
<ul>
<li>Tag our official accounts: [INSERT HANDLES]</li>
<li>Use hashtags: [INSERT HASHTAGS]</li>
<li>Include app screenshots or interface footage</li>
<li>Mention key benefit: [INSERT MAIN VALUE PROP]</li>
</ul>

<h3>Content Standards:</h3>
<ul>
<li>High production quality</li>
<li>Authentic and genuine tone</li>
<li>No misleading claims</li>
<li>Professional presentation</li>
<li>Clear audio and visuals</li>
</ul>

<h2>Success Tips</h2>
<ol>
<li>Post during peak hours for your audience</li>
<li>Engage with comments to boost performance</li>
<li>Create content that encourages shares</li>
<li>Focus on educational value while entertaining</li>
<li>Show real results and experiences</li>
</ol>

<p><strong>Ready to take on the challenge? Let's create something amazing together!</strong></p>`;

export const getTemplateBrief = (
  campaignType: "CiR" | "influencer" | "challenge",
) => {
  return campaignType === "challenge" ? challengeTemplateBrief : templateBrief;
};

export const getTemplateCreatorCriteria = () => [
  {
    title: "Creator Brief Alignment",
    description:
      "How well does the creator's content style and approach align with our campaign brief and brand guidelines?",
    weight: 70,
  },
  {
    title: "Content Quality & Production Value",
    description:
      "Evaluate the visual quality, editing skills, audio clarity, and overall production value of submitted videos.",
    weight: 30,
  },
];
